import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaHome, FaUsers, FaPlusSquare, FaCogs, FaSignOutAlt, FaBars, FaTimes, FaBell } from "react-icons/fa";
import { useAuth } from "../../services/AuthContext";

const Sidebar = () => {
  const { logout } = useAuth();
  const location = useLocation();
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const menuItems = [
    { path: "/dashboard", icon: <FaHome />, label: "Ana səhifə" },
    { path: "/dashboard/users", icon: <FaUsers />, label: "İstifadəçilər" },
    { path: "/dashboard/memorial-profiles", icon: <FaPlusSquare />, label: "Postlar" },
     { path: "/dashboard/referrals", icon: <FaBell />, label: "Referal" }, 
    // { path: "/dashboard/send-notification", icon: <FaBell />, label: "Bildirişlər" },
    { path: "/dashboard/settings", icon: <FaCogs />, label: "Parametrlər" },
  ];

  const toggleMobile = () => setIsMobileOpen(!isMobileOpen);

  return (
    <>
      <button className="hy-sidebar-mobile-toggle" onClick={toggleMobile}>
        {isMobileOpen ? <FaTimes /> : <FaBars />}
      </button>

      <aside className={`hy-sidebar ${isMobileOpen ? 'hy-sidebar-open' : ''}`}>
        <div className="hy-sidebar-header">
          <div className="hy-sidebar-logo">
            <div className="hy-sidebar-logo-icon">🕊️</div>
            <h2 className="hy-sidebar-logo-text">HeyatYolu</h2>
          </div>
        </div>

        <nav className="hy-sidebar-nav">
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`hy-sidebar-nav-item ${isActive ? 'hy-sidebar-nav-item-active' : ''}`}
                onClick={() => setIsMobileOpen(false)}
              >
                <span className="hy-sidebar-nav-icon">{item.icon}</span>
                <span className="hy-sidebar-nav-label">{item.label}</span>
                {isActive && <div className="hy-sidebar-nav-indicator" />}
              </Link>
            );
          })}
        </nav>

        <div className="hy-sidebar-footer">
          <button onClick={logout} className="hy-sidebar-logout-btn">
            <FaSignOutAlt />
            <span>Çıxış</span>
          </button>
        </div>
      </aside>

      {isMobileOpen && (
        <div className="hy-sidebar-overlay" onClick={toggleMobile} />
      )}
    </>
  );
};

export default Sidebar;